/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { CSSTransitionGroup } from 'react-transition-group';
import browserUtils from '../../../../modules/common/services/browserUtils';
import Async from '../../../Async';
import Nav from './components/Nav';

import t from '../../../../css/global.module.css';
import s from './navAndMenuCtn.module.css';


const ShowMenu = props => (
  <Async
    promise={
      import(
        /* webpackChunkName: "Menu" */
        /* webpackMode: "lazy" */
        // eslint-disable-next-line function-paren-newline
        './components/Menu')
    }
    {...props}
  />
);

class NavAndMenuCtn extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      menuOpened: false,
      mouseOverMenu: false,
    };
    this.onMenuClick = this.onMenuClick.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    this.openMenu = this.openMenu.bind(this);
    this.onMouseEnterMenu = this.onMouseEnterMenu.bind(this);
    this.onMouseLeaveMenu = this.onMouseLeaveMenu.bind(this);
    this.forceloseMenu = this.forceloseMenu.bind(this);
    this.willOpenMenu = this.willOpenMenu.bind(this);
  }

  componentDidMount() {
    this.context.storeHelper.defineCloseMenu(this.forceloseMenu);
  }

  componentWillReceiveProps(nextProps) {
    const { menuOpened } = this.state;
    if (nextProps.searchHasFocus && menuOpened) {
      this.forceloseMenu();
    }
  }

  onMenuClick() {
    const { menuOpened } = this.state;
    this.setState({
      menuOpened: !menuOpened,
    });
  }

  onMouseLeaveMenu() {
    this.setState({
      mouseOverMenu: false,
    });
    this.closeMenu();
  }

  onMouseEnterMenu() {
    this.setState({
      mouseOverMenu: true,
    });
    this.willOpenMenu();
    if (this.props.rgpdIsActive && !browserUtils.getCookie('rgpd')) {
      this.context.storeHelper.hideCnilBanner();
      browserUtils.createRgpdCookie();
      if (this.props.rgpdDisableFirstHit) {
        browserUtils.triggerMonetization(this.context.md.wsParams);
      }
    }
  }

  componentDidUnMount() {
    this.context.storeHelper.defineCloseMenu();
  }

  willOpenMenu() {
    setTimeout(() => {
      this.openMenu();
    }, 300);
  }

  openMenu() {
    if (this.state.menuOpened === false && this.state.mouseOverMenu) {
      this.setState({
        menuOpened: true,
      });
    }
  }

  closeMenu() {
    setTimeout(() => {
      if (this.state.mouseOverMenu === false) {
        this.setState({
          menuOpened: false,
          mouseOverMenu: false,
        });
      }
    }, 100);
  }

  forceloseMenu() {
    setTimeout(() => {
      this.setState({
        menuOpened: false,
        mouseOverMenu: false,
      });
    }, 50);
  }

  renderIE(navMenuButtonProps) {
    const { personalized, menu, ...others } = this.props;
    return (
      <div className={`${t.mt2} ${t.mb2} ${t['z-10']}`}>
        <Nav personalized={personalized} {...others} menu={navMenuButtonProps} />
        {
          this.state.menuOpened
          && (
            <div className={`${t.relative} ${t['z-999']}`}>
              <ShowMenu
                classNameLoader={`${s.wrapper} ${t.absolute} ${t.flex}`}
                isOpened={this.state.menuOpened}
                {...menu}
                onMouseEnterMenu={this.onMouseEnterMenu}
                onMouseLeaveMenu={this.onMouseLeaveMenu}
              />
            </div>
          )}
      </div>
    );
  }

  render() {
    const { menu, personalized, helpLink, ...others } = this.props;
    const mobileDetect = this.context.md;
    const { menuOpened } = this.state;
    const navMenuButtonProps = {
      isOpen: this.state.menuOpened,
      onClick: this.onMenuClick,
      onHoverIn: this.onMouseEnterMenu,
      onHoverOut: this.onMouseLeaveMenu,
      labels: menu.labels,
    };

    if (mobileDetect.ie) {
      return this.renderIE(navMenuButtonProps);
    }

    return (
      <div className={`${t.mt2} ${t.mb2} ${t['z-10']}`}>
        <Nav personalized={personalized} {...others} menu={navMenuButtonProps} helpLink={helpLink} />
        <CSSTransitionGroup
          component="div"
          transitionName="menuCtn"
          transitionEnterTimeout={500}
          transitionLeaveTimeout={mobileDetect.mobile ? 500 : 50}
        >
          {menuOpened
          && (
            <div className={`${t.relative} ${t['z-999']}`}>
              <ShowMenu
                classNameLoader={`${s.wrapper} ${t.absolute} ${t.flex}`}
                isOpened={menuOpened}
                {...menu}
                onMouseEnterMenu={this.onMouseEnterMenu}
                onMouseLeaveMenu={this.onMouseLeaveMenu}
                onOutsideClick={this.closeMenu}
              />
            </div>
          )}
        </CSSTransitionGroup>
      </div>
    );
  }
}


NavAndMenuCtn.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  personalized: PropTypes.object,
  menu: PropTypes.objectOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  ).isRequired,
  rgpdIsActive: PropTypes.bool,
  rgpdDisableFirstHit: PropTypes.bool,
  searchHasFocus: PropTypes.bool,
  helpLink: PropTypes.string,
  conversationIsActive: PropTypes.bool.isRequired,
  merchantCenterIsActive: PropTypes.bool.isRequired,
  merchantCenterBetaTesters: PropTypes.arrayOf(PropTypes.string).isRequired,
};
NavAndMenuCtn.defaultProps = {
  personalized: {},
  searchHasFocus: false,
  rgpdIsActive: false,
  rgpdDisableFirstHit: false,
  helpLink: undefined,
};
NavAndMenuCtn.contextTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  storeHelper: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  md: PropTypes.object,
};

export default NavAndMenuCtn;
